import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios'

import { useAuthStore } from '@/store/auth/auth'

export const dPoPRequestInterceptor = async (
  config: InternalAxiosRequestConfig
) => {
  const publicJwk = useAuthStore.getState().publicJwk
  if (!publicJwk) {
    return config
  }
  const dPoPToken = await useAuthStore.getState().generateDPoPToken()
  const authToken = useAuthStore.getState().authToken
  if (dPoPToken) {
    config.headers['DPoP'] = dPoPToken
  }
  if (authToken) {
    config.headers['Authorization'] = authToken
  }
  return config
}

export const dPoPResponseInterceptor = (response: AxiosResponse) => {
  const publicJwk = useAuthStore.getState().publicJwk
  if (response.headers.authorization && publicJwk) {
    const setAuthToken = useAuthStore.getState().setAuthToken
    setAuthToken(response.headers.authorization as string)
  }
  return response
}

export const defaultErrorHandler = (error: AxiosError) => Promise.reject(error)
